import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppNav from "../components/appNav";
import Footer from "../components/footer";
import PageSection from "../components/PageSection";
import ArrowIcon from "../components/ArrowIcon";

interface Row { place: string; body: string; linkText: string; linkUrl: string }

const CaseStudiesPage = () => {
  const { t } = useTranslation();
  const rows = t("kode.caseStudies.rows", { returnObjects: true }) as unknown as Row[];

  return (
    <div className="min-h-screen bg-paper text-ink">
      <header className="sticky top-0 z-50 bg-paper/95 backdrop-blur-[2px] border-b border-ink-14">
        <AppNav />
      </header>

      <main>
        {/* 01 / Case studies hero */}
        <PageSection marker={t("kode.caseStudies.sectionLabel")} noTop topPadClass="!pt-12">
          <h1 className="section-h-lg">
            {t("kode.caseStudies.h1Line1")}
            <br />
            {t("kode.caseStudies.h1Line2")}
          </h1>
          <p className="text-body-lg text-ink-70 mt-6" style={{ maxWidth: "60ch" }}>
            {t("kode.caseStudies.lead")}
          </p>
        </PageSection>

        {/* 02 / Deployments */}
        <PageSection marker={`02 / ${t("kode.common.deployed")}`}>
          <div className="deployed">
            {rows.map((r, i) => (
              <div className="row" key={i}>
                <div className="ix">{String(i + 1).padStart(2, "0")}</div>
                <div>
                  <h4 className="place">{r.place}</h4>
                  <p>{r.body}</p>
                  <a href={r.linkUrl} target="_blank" rel="noreferrer" className="extlink">
                    {r.linkText}
                    <ArrowIcon />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </PageSection>

        {/* 03 / Talk */}
        <PageSection marker={`03 / ${t("kode.common.talk")}`}>
          <h3 className="section-h">{t("kode.caseStudies.talkH3")}</h3>
          <p className="section-sub">{t("kode.caseStudies.talkSub")}</p>
          <div className="flex flex-wrap gap-3 mt-5">
            <Link to="/contact" className="btn btn-primary">
              {t("kode.common.bookCall")}
              <ArrowIcon className="h-4 w-4" />
            </Link>
            <a href="mailto:hugo@kode.zone" className="btn btn-secondary">
              hugo@kode.zone
            </a>
          </div>
        </PageSection>

        <Footer />
      </main>
    </div>
  );
};

export default CaseStudiesPage;
